export const ApiConfig = {
  allPopList: {
    staleTime: 300000, // in seconds ~ 5 minutes
    cacheTime: 600000,
    retry: 1,
    enabled: true,
  },
  projects: {
    staleTime: 60000,
    cacheTime: 300000,
    retry: 2,
    enabled: true,
  },
  transactions: {
    staleTime: 120000,
    cacheTime: 300000,
    retry: false,
    enabled: true,
  },
  common: {
    staleTime: 300000, // in seconds ~ 5 minutes
    cacheTime: 600000,
    retry: 1,
    enabled: true,
  },
};

export const defaultFetchConfig = {
  pageNumber: 1, pageSize: 50 
};
